
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { checkPicVerifyCode, getCode } from '@/api/other';
import { updataUserInfo, logout, getUserInfo } from '@/api/users';

@Component({
  name: 'CompanyComplete',
  components: {

  }
})
export default class extends Vue {
  private form: any = {
    name: '',
    mobile: '',
    code: '',
    picCode: '',
    picInputCode: ''
  }
  private dialogVerifyCodeVisible=false;
  private _height: any = '';
  private mobile:any='';
  private name:any=''

  created() {
    this.$set(this.form, 'name', this.$route.query.name);
    this.$set(this.form, 'mobile', this.$route.query.mobile);
    this.mobile = this.$route.query.mobile
    this.name = this.$route.query.name
    this._height = window.innerHeight;
  }

  private sendCodeHandle() {
    this.send(1);
  }
  private imgVerifyClick() {
    this.send(0);
  }

  private send(type:number) {
    if (!this.form.mobile) {
      this.showErrorMsg('请输入手机号');
      return;
    }
    if (this.form.mobile) {
      var telRegex = /^1\d{10}$/;
      if (!telRegex.test(this.form.mobile)) {
        this.showErrorMsg('请输入正确的手机号');
        return;
      }
    }
    let map:any = {};
    map.send_type = 23;
    map.mobile = this.form.mobile;
    map.user_id = UserModule.getUserId;
    getCode(map).then(res => {
      if (res.data && res.data.image_code) {
        this.form.picCode = res.data.image_code;
        if (type === 1) {
          this.$set(this.form, 'picInputCode', '');
          this.dialogVerifyCodeVisible = true;
        }
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private timedown:any = 60;
  private sendtext = '发送验证码';
  private timer:any = '';
  private checkPicVerify() {
    let map:any = {};
    map.user_id = UserModule.getUserId;
    map.send_type = 23;
    map.mobile = this.form.mobile;
    map.image_code = this.form.picInputCode;
    checkPicVerifyCode(map).then(res => {
      this.showSecussMsg('验证码已发送');
      this.dialogVerifyCodeVisible = false;
      this.sendtext = this.timedown + 's';
      this.timer = setInterval(() => {
        this.timedown--;
        if (this.timedown <= 0) {
          clearInterval(this.timer);
          this.timedown = 60;
          this.sendtext = '重新获取';
          return;
        }
        this.sendtext = this.timedown + 's';
      }, 1000);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private saveInfo() {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    if (!this.name) {
      if (!this.form.name) {
        this.showErrorMsg('请输入您的姓名');
        return;
      }
      if (this.form.name.length < 2 || this.form.name.length > 20) {
        this.showErrorMsg('请输入2-20位的姓名');
        return;
      }
      pamars.user_name = this.form.name;
    }
    if (!this.mobile) {
      if (!this.form.mobile) {
        this.showErrorMsg('请输入手机号');
        return;
      }
      var telRegex = /^1\d{10}$/;
      if (!telRegex.test(this.form.mobile)) {
        this.showErrorMsg('请输入正确的手机号');
        return;
      }
      pamars.mobile = this.form.mobile;
      if (!this.form.code) {
        this.showErrorMsg('请输入验证码');
        return;
      }
      if (this.form.code.length < 4 || this.form.code.length > 6) {
        this.showErrorMsg('请输入4-6位的验证码');
        return;
      }
      pamars.verify_code = this.form.code;
      pamars.send_type = 23;
    }
    updataUserInfo(pamars).then(async(res:any) => {
      this.showSecussMsg(res.msg);
      await getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async(res:any) => {
        await UserModule.setLogin(res.data);
        this.$router.push({
          path: "/Index",
          query: {}
        }).catch(err => {
          let msg = err
        });
      });

    // setTimeout(() => {
    //       window.parent.location.reload();
    //     }, 1500);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private logout() {
    let parmas:any = {};
    parmas.account_id = UserModule.getAccountId;
    logout(parmas).then(res => {
      this.showSecussMsg('退出成功');
      UserModule.ResetToken();
      window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
    }).catch(err => {
      this.showSecussMsg(err.msg);
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
